'use strict';

export function showAddLocationPopup(options) {

    if (!options){
        options = {};
    }

    var popupTitle = 'Add Farm';

    if (!options.newRecord) {
        options.newRecord = false;
    }

    var addLocationURL = '/pages/pop/?' + jQuery.param({
        module: 'location',
        page: 'locationAdd',
        newRecord: true,
    });

    popWin({
        title: popupTitle,
        noAutoWidth: true,
        popID: 'addLocationPop',
        width: 600,
        modal: true,
        page: addLocationURL,
        dataType: 'json',
        buttons: {
            'Save': function() {
                saveForm('form_settings_list_farm',false, (data) =>
                {
                    var data = jQuery.parseJSON(data);
                    if (data.SAVED == 'true'){
                        popWinClose('addLocationPop');
                        $('#list').trigger('reloadGrid');
                    } else {
                        alert(data.RESULTMSG);
                    }
                });
            },
            'Close': function() {
                $(this).dialog('close');
            },
        },
    });
}

export function init(options) {
    if (!options) {
        options = {};
    }
    $('.jq_button').button();
}